import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigurationService } from '@universis/common';
import { Title } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import merge from 'lodash-es/merge';
import { ApplicationSettings } from './evaluations-shared/evaluations-shared.module';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'universis-app9';
  translationChangeSubscription: Subscription;

  public constructor(private _config: ConfigurationService,
                     private _titleService: Title,
                     private _translateService: TranslateService) {
                      this._config.loaded.subscribe((config) => {
                        if (config) {
                          const append = config.settings.i18n?.append;
                          if (append) {
                            if (this.translationChangeSubscription) {
                              this.translationChangeSubscription.unsubscribe();
                            }
                            this.translationChangeSubscription = this._translateService.onTranslationChange.subscribe(({lang}) => {
                              if (Object.prototype.hasOwnProperty.call(append, lang)) {
                                const translations = this._translateService.translations[lang];
                                this._translateService.translations[lang] = merge(translations, append[lang]);
                              }
                            });
                          }
                        }
                      });
  }
  ngOnDestroy(): void {
    if (this.translationChangeSubscription) {
      this.translationChangeSubscription.unsubscribe();
    }
  }

  public setTitle( newTitle: string): void {
    this._titleService.setTitle( newTitle );
  }

  async ngOnInit(): Promise<void> {
    const customTitle = (<ApplicationSettings>this._config.settings.app) && (<ApplicationSettings>this._config.settings.app).title;

    if (customTitle && customTitle.trim() !== '') {
      this.setTitle(customTitle);
    }
  }

}
